"use strict";

var RoutePath = require('../constants/routePath');
var ModulePath = require('../constants/modulePath');
var moduleCodes = require('../constants/moduleCodes');
var raPath = ModulePath[moduleCodes.MODULE_RA];

var RouterUtility = require('../utils/routerUtility');

/**
 * Wrapper for RA routes
 * @type {{getHome: RaRouteWrapper.getHome, getLearnerPortfolio: RaRouteWrapper.getLearnerPortfolio, getLatestAssessments: RaRouteWrapper.getLatestAssessments, getReport: RaRouteWrapper.getReport, getRa: RaRouteWrapper.getRa, _getFullRoutePath: RaRouteWrapper._getFullRoutePath}}
 */
var RaRouteWrapper = {
  getHome: function () {
    return this._getFullRoutePath(RoutePath.ROUTE_RA_HOME);
  },

  getLearnerPortfolio: function (id) {
    var fullRoutePath = RaRouteWrapper._getFullRoutePath(RoutePath.ROUTE_RA_LEARNER_PORTFOLIO);
    return fullRoutePath.replace(':id', id);
  },

  getLatestAssessments: function () {
    return this._getFullRoutePath(RoutePath.ROUTE_RA_LATEST_ASSESSMENTS);
  },

  getReport: function (reportType) {
    var fullRoutePath = this._getFullRoutePath(RoutePath.ROUTE_RA_REPORTS);
    fullRoutePath = fullRoutePath + '?reportType=' + reportType;
    return fullRoutePath;
  },

  getRa: function () {
    return '/' + raPath;
  },

  _getFullRoutePath: function (routePath) {
    var fullRoutePath = RouterUtility.getRoutePath(raPath, routePath);
    return fullRoutePath;
  },
};
module.exports = RaRouteWrapper;
